import React, { useState, useEffect } from "react";
import TreeView from "@mui/lab/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TreeItem from "@mui/lab/TreeItem";
import axios from "axios";
import { Box, Container, CssBaseline, Grid, Paper, TextField, ThemeProvider, Typography, createTheme } from '@mui/material'
import PersonIcon from "@mui/icons-material/Person";
import FolderIcon from '@mui/icons-material/Folder';
import FileInfoTable from "./FileInfoTable";
import Button from '@mui/material/Button';


const mdTheme = createTheme();

interface FileData {
  id: number;
  email: string;
  name: string;
  origin_name: string;
  new_name: string;
  extension: string;
  file_dir: string;
  upload_date: string;
}

const WorkTree = (props:any) => {
  const [folderList, setFolderList] = useState([]);
  const [extension,setExtension]=useState("")
  const [user,setUser]=useState("")
  const getFileList = async () => {
    var result = await axios.get("http://localhost:9680/uploadFileDir", {
      params:{extension:extension,email:user},
      withCredentials: true,
    });

    const extensiondatas = result.data.datas.map((data: any) => {
      return data.extension;
    });

    const userdatas = result.data.datas.map((data: any) => {
      return data.email;
    });

    console.log("데이터",result.data.datas)
    setFolderList(result.data.datas);
  };

  useEffect(() => {
    getFileList();
  },[]);

  const [path, setPath] = useState("");
  const [tableParam , setTableParam] = useState("");

  const updatePath = (path:any) => {
    let updatePath = "work1"  
    
    console.log('path::: ', path)
    updatePath= updatePath+"/"+path
    
    setPath(updatePath)
    
  };

  const loadFileInfoTable = () => {
    
    setTableParam(path)
    console.log('tableParam',tableParam)
  }
  
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "94vh",
            overflow: "auto",
          }}
        >
          <Container maxWidth="xl" sx={{ mt: 3, mb: 3 }}>
            <Grid container spacing={3}>
              {/* Chart */}
              <Grid item xs={2}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <Box sx={{border:1 ,marginBottom:2}}>
                    <Box sx={{marginLeft:"8px", fontSize:"14px", fontWeight:700}}>{path||"work1"}</Box>
                  </Box>
                  <Button sx={{marginBottom:2}} variant="contained" onClick={()=> loadFileInfoTable()}>목록보기</Button>
                  <TreeView
                    aria-label="file system navigator"
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    multiSelect
                    
                    sx={{ height: "94vh", flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
                    
                  >
                    {folderList.length > 0 ? folderList.map((work:any, index:number) => {
                      return (
                        <TreeItem key={"work1_"+index.toString()} nodeId={"work1_"+index.toString()} onClick={() => { setPath("work1"); } } label={<Box sx={{display:"flex", verticalAlign:"middle"}}><FolderIcon style={{ fill: '#ffea2c'}} /> <Box sx={{marginLeft:"2px", fontWeight:700}}>{work.folderName}</Box></Box>} >
                          {work.children.length > 0 ? work.children.map((stage:any, index2:number)=> {
                            var stage_key = stage.folderName.toString()
                            return(
                              <TreeItem key={stage_key+"stage_"+index2.toString()} nodeId={stage_key+"stage_"+index2.toString()} onClick={() => { updatePath(stage_key);   }  }  label={<Box sx={{display:"flex", verticalAlign:"middle"}}><FolderIcon style={{ fill: '#ffea2c' }}/><Box sx={{marginLeft:"2px", fontWeight:700}}>{stage.folderName}</Box></Box>}  >
                                {stage.children.length > 0 ? stage.children.map((ymd:any, index3:number)=> {
                                  var ymd_key = ymd.folderName.toString()
                                  return (
                                    <TreeItem key={stage_key+"ymd_"+index3.toString()} nodeId={stage_key+"ymd_"+index3.toString()} onClick={() => { updatePath(stage_key+"/"+ymd_key);    }  } label={<Box sx={{display:"flex", verticalAlign:"middle"}}><FolderIcon style={{ fill: '#ffea2c' }}/><Box sx={{marginLeft:"2px", fontWeight:700}}>{ymd.folderName}</Box> <Box sx={{fontSize:"6px", fontWeight:600, color:"#ff7600", marginLeft:"2px"}}> [{ymd.children.length}]</Box></Box>}>
                                      {ymd.children.length > 0 ? ymd.children.map((user:any,index4:number)=>{
                                        var user_key = user.folderName.toString()
                                        return(
                                          <TreeItem key={stage_key+ymd_key+"user_"+index4.toString()} nodeId={stage_key+ymd_key+"user_"+index4.toString()} onClick={() => {updatePath(stage_key+"/"+ymd_key+"/"+user_key);  }} label={<Box display="flex"><PersonIcon fontSize="small" style={{ fill: '#006eff' }}/><Box sx={{fontSize:"14px", marginLeft:"2px", fontWeight:700}}>{user.folderName}</Box> <Box sx={{fontSize:"6px", fontWeight:600, color:"blue", marginLeft:"2px"}}> [{user.data.length}]</Box></Box>}>
                                            
                                          </TreeItem>
                                        )
                                      }):""}
                                  </TreeItem>
                                  )
                                }): ""}
                              </TreeItem>
                            )
                          }) : ""}
                        </TreeItem>
                      )
                    }): <Box>데이터가 없습니다.</Box>}
                  </TreeView>

                    
                </Paper>
              </Grid>
              <Grid item xs={10}>
                <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                  <FileInfoTable path={tableParam} />
                </Paper>
              </Grid>
              {/* Recent Deposits */}
              
            </Grid>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>



    
  );
}

export default WorkTree;